import { QuestionMethods } from '../questionMethods.types';
import {
	MultipleSelectGivenAnswer,
	RenderedMultipleSelectQuestion,
} from './multipleSelectMethods.types';

export const isMultipleSelectAnswered: QuestionMethods<
	RenderedMultipleSelectQuestion,
	MultipleSelectGivenAnswer
>['isAnswered'] = ({ question, givenAnswers }) => {
	const givenAnswer = givenAnswers.multiple.get(question.id);
	if (givenAnswer == null) return false;

	// An empty set indicates the user has explicitly answered "no answer"
	if (givenAnswer.size === 0) return true;

	return question.answers.some((answer) => givenAnswer.has(answer.id));
};
